module.exports = __webpack_public_path__ + "static/img/onboarding-discount.97eec3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onboarding-discount.png
// module id = x2eP
// module chunks = 6